export const SET_QUESTION = "SET_QUESTION";
export const SET_QUESTIONGROUP = "SET_QUESTIONGROUP";
export const SET_CATEGORY = "SET_CATEGORY";
export const STORE_CATEGORIES = "STORE_CATEGORIES";
export const STORE_GROUP = "STORE_GROUP";
export const STORE_CATEGORY = "STORE_CATEGORY";